import React from "react";
import { Button, Modal } from "react-bootstrap";
//import styles from "../css/ui.module.css";   // adjust relative path as needed

export const ConfirmModal = ({ show, question, onYes, onNo }) => {
  return (
 
    <Modal show={show} 
      onHide={onNo} 
      centered 
      backdrop="static" 
      keyboard={false} >
      <Modal.Header closeButton>
        <Modal.Title><span role="img" aria-label="Warning">⚠️</span> Warning</Modal.Title>
      </Modal.Header>
      <Modal.Body>{question}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onNo}>
          No
        </Button>
        <Button variant="primary" onClick={onYes}>
          Yes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
